<ng-template id="history" #history bsModal class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="LatestUpdate" aria-hidden="true">
    <div class="modal-header bg-info text-white">
        <p class="modal-title">
            <strong class="mr-1">Tax technical archive for {{title}} section</strong>
        </p>
        <button type="button" class="btn btn-sm btn-info" aria-label="Close" (click)="modalInstance.hide()">
            <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
    </div>
    <div class="modal-body p-0 pb-1">
        <div class="row row--content user-content">
            <div class="col">
                <ul class="list-group">
                    <div class="p-3" id="loadingPlaceholder" [hidden]="!showLoading">Loading...</div>
                    @for (auditItem of auditHistory; track auditItem; let i = $index; let isFirst = $first) {
                    <history-modal-item [auditItem]="auditItem" [isFirst]="isFirst"></history-modal-item>
                    }
                </ul>
            </div>
        </div>
    </div>
</ng-template>